import axios from 'axios';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { Skeleton } from '../../ui';
import { FlexContainer } from '../../ui/Container';
import StripeEmbeddedCheckout from './StripeEmbeddedCheckout';
import StripeError from './StripeError';

type Props = {
  stripeProductId: string;
  membershipStatusId: string;
  customer_email: string;
  upgrade?: boolean;
};

const fetchClientSecret = async ({ queryKey }) => {
  const [, stripeProductId, membershipStatusId, customer_email, upgrade] = queryKey;
  // Create a Checkout Session
  const res = await axios.post('/stripe/checkout', {
    priceId: stripeProductId,
    membershipStatusId,
    customer_email,
    ...(upgrade && { upgrade }),
  });
  if (!res) return '';
  if (res.status !== 200) return undefined;
  return res.data;
};

const StripeUnpaidMembershipCheckout: FC<Props> = ({
  stripeProductId,
  membershipStatusId,
  customer_email,
  upgrade,
}) => {
  const { isLoading, data } = useQuery(
    ['stripeClientSecret', stripeProductId, membershipStatusId, customer_email, upgrade],
    fetchClientSecret
  );

  if (isLoading)
    return (
      <FlexContainer flexDirection="column" gap="xs">
        <Skeleton height={25} count={5} />
      </FlexContainer>
    );

  // Has loaded but there no checkout available
  if (!isLoading && !data) return <StripeError />;

  // For unpaid memberships, always use regular checkout (no upgrade logic)
  return <StripeEmbeddedCheckout stripeData={data} />;
};

export default StripeUnpaidMembershipCheckout;
